export default __webpack_public_path__ + "img/886bbac194dc9ce7adc174487928c408.png";